<template>
  <b-form-group :label-for="name">
    <template v-if="label" #label>
      {{ label }}<span v-if="isRequired" class="text-danger"> *</span>
    </template>
    <validation-provider
      :name="name"
      :rules="validate"
      :bails="false"
      #default="{ errors }"
    >
      <select
        :id="id"
        :disabled="disabled"
        :class="['form-control bg-white', { 'is-invalid': errors.length > 0 }]"
        :value="value"
        @change="$emit('input', $event.target.value)"
      >
        <option disabled value="">{{ placeholder }}</option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option.value"
        >
          {{ option.text }}
        </option>
      </select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      default: '',
      type: String
    },
    name: {
      default: '',
      type: String
    },
    id: {
      default: '',
      type: String
    },
    validate: {
      default: '',
      required: false
    },
    placeholder: {
      default: 'Select an option'
    },
    disabled: {
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isRequired () {
      return isFieldRequired(this.validate)
    }
  }
}

function isFieldRequired (validate) {
  if (!validate) return false
  if (typeof validate === 'object') {
    return validate.required === true || validate.required === ''
  }
  return String(validate).split('|').some(rule => {
    const name = rule.split(':')[0].trim()
    return name === 'required' || name === 'arabic_name' || name === 'english_name'
  })
}
</script>
